import { IGetMaquinaEquipArquivoByIdUseCase } from "../../../presentation/useCases/read/get_maquina_equip_arquivo_by_id_use_case";
import { GetMaquinaEquipArquivoByIdRequestModel, GetMaquinaEquipArquivoByIdResponseModel } from "../../models/MaquinasEquipItensArquivo";
import { IControlePatrimonioRepository } from "../../repositories/ControledePatrimonio";

/**
 * GetMaquinaEquipArquivoByIdUseCase
 */

export class GetMaquinaEquipArquivoByIdUseCase implements IGetMaquinaEquipArquivoByIdUseCase {
  constructor(private readonly repository: IControlePatrimonioRepository) {}

  async getMaquinaEquipArquivoById(request: GetMaquinaEquipArquivoByIdRequestModel): Promise<GetMaquinaEquipArquivoByIdResponseModel> {
    return await this.repository.getControledePatrimonioMaquinaEquipArquivoById(request);
  }
}
